// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1Qwou","label":"Category_label__2BGZj","content":"Category_content__2pgTC","header":"Category_header__2Y5DF","location":"Category_location__3Xt88"};